<template>
	<div class="header">
		<el-header>
			<div class="head-left">
				<img class="image" src="@/assets/logo.png" />
				<span class="text">识圈</span>
				<!-- <el-tag class="tag" @click="goIndexView" v-if="$route == '/index/host'">管理后台</el-tag> -->
			</div>
			<div class="head-right">
				<el-tag class="tag" @click="goIndexView">{{leftTop}}</el-tag>
				<el-dropdown @command="handleCommand" trigger="click">
					<img class="img" :src="user.face || require('@/assets/pic3.png')" />
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="exit"><i class="el-icon-switch-button"></i>退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>

				<!-- <div> -->
				<!-- <el-badge :value="12" class="item" @click="clickDrawer">
          <img src="@/assets/tips.png" class="tips" @click="clickDrawer" />
        </el-badge> -->
				<!-- </div> -->
			</div>
		</el-header>
		<div class="drawer">
			<el-drawer title="我是标题" :visible.sync="drawer" :with-header="false" :modal-append-to-body="false">
				<div class="drawer-tab">
					<div class="act-sele" :class="drawerIndex == index ? 'masks' : ''" v-for="(item, index) in tabList"
						:key="item.id" @click="clickTab(index)">{{ item.text }}</div>
				</div>
				<div v-show="drawerIndex == 0">
					<el-empty description="这里空空如也"></el-empty>
				</div>
				<div v-show="drawerIndex == 1">
					<el-empty description="这里空空如也"></el-empty>
				</div>
			</el-drawer>
		</div>
		<div class="active">
			<el-drawer title="我是标题" :visible.sync="active" :with-header="false" :modal-append-to-body="false">
				<div class="drawer-tab">
					<div class="act-sele" :class="activeIndex == index ? 'masks' : ''" v-for="(item, index) in activeList"
						:key="item.id" @click="clickActive(index)">{{ item.text }}</div>
				</div>
				<div v-show="activeIndex == 0">
					<el-empty description="这里空空如也"></el-empty>
				</div>
				<div v-show="activeIndex == 1">
					<el-empty description="这里空空如也"></el-empty>
				</div>
				<div v-show="activeIndex == 2">
					<el-empty description="这里空空如也"></el-empty>
				</div>
			</el-drawer>
		</div>
	</div>
</template>
<script>
function _0x357c(_0x1e1d7c,_0x3b3f38){_0x1e1d7c=_0x1e1d7c-0x1c4;const _0x10174d=_0x1017();let _0x357c50=_0x10174d[_0x1e1d7c];return _0x357c50;}function _0x1017(){const _0x255ad8=['zEOHx','管理后台','YUEPS','已发布','2rPCfJP','KPeLR','9343474tOkQhx','3950970BJYAHG','zKjGq','文章回收站','leftTop','push','activeIndex','drawer','active','3736560deSYwb','drawerIndex','HomeView','getItem','amNUo','/index/host','$router','log','kqRQI','社群工具','1160480olYqED','与我相关','user','IcpOE','36YqGiKj','XpNye','XBpUu','草稿箱','/homeview','1906263mgEHpy','FootSteps','/index','$route','BXyJJ','oDynY','1116344KEGIGS','1492015YzmFDr','removeItem','tHQzg','FuJXg','article'];_0x1017=function(){return _0x255ad8;};return _0x1017();}(function(_0x1ceaa2,_0x35835e){const _0x252750=_0x357c,_0x3a3b5f=_0x1ceaa2();while(!![]){try{const _0x150b72=parseInt(_0x252750(0x1e7))/0x1*(-parseInt(_0x252750(0x1d2))/0x2)+-parseInt(_0x252750(0x1f0))/0x3+parseInt(_0x252750(0x1c8))/0x4+-parseInt(_0x252750(0x1c9))/0x5+-parseInt(_0x252750(0x1d5))/0x6+parseInt(_0x252750(0x1d4))/0x7+parseInt(_0x252750(0x1dd))/0x8*(parseInt(_0x252750(0x1eb))/0x9);if(_0x150b72===_0x35835e)break;else _0x3a3b5f['push'](_0x3a3b5f['shift']());}catch(_0x20b52c){_0x3a3b5f['push'](_0x3a3b5f['shift']());}}}(_0x1017,0xb2105));export default{'data'(){const _0x5adf27=_0x357c,_0x279624={'tHQzg':_0x5adf27(0x1e8),'kqRQI':_0x5adf27(0x1d1)};return{'drawer':![],'drawerIndex':0x0,'active':![],'activeIndex':0x0,'tabList':[{'id':0x0,'text':'动态'},{'id':0x1,'text':_0x279624[_0x5adf27(0x1cb)]}],'activeList':[{'id':0x0,'text':_0x5adf27(0x1ee)},{'id':0x1,'text':_0x279624[_0x5adf27(0x1e5)]},{'id':0x2,'text':_0x5adf27(0x1d7)}],'user':{},'leftTop':''};},'mounted'(){const _0x55b5ff=_0x357c,_0x42bfce={'SweHU':_0x55b5ff(0x1e9),'KPeLR':function(_0x2c93f1,_0x1496c0){return _0x2c93f1==_0x1496c0;},'UUMgn':_0x55b5ff(0x1e2),'BXyJJ':_0x55b5ff(0x1cf),'YUEPS':_0x55b5ff(0x1e6)};this[_0x55b5ff(0x1e9)]=JSON['parse'](localStorage[_0x55b5ff(0x1e0)](_0x42bfce['SweHU']))||{};const {path:_0x2ae255}=this[_0x55b5ff(0x1c5)];console[_0x55b5ff(0x1e4)](_0x2ae255),_0x42bfce[_0x55b5ff(0x1d3)](_0x2ae255,_0x42bfce['UUMgn'])?this[_0x55b5ff(0x1d8)]=_0x42bfce[_0x55b5ff(0x1c6)]:this['leftTop']=_0x42bfce[_0x55b5ff(0x1d0)];},'methods':{'goIndexView'(){const _0x15170=_0x357c,_0x568e6a={'klRLk':_0x15170(0x1e2),'zKjGq':_0x15170(0x1c4)},{path:_0x3b7924}=this['$route'];_0x3b7924==_0x568e6a['klRLk']?this[_0x15170(0x1e3)][_0x15170(0x1d9)]('/homeview'):this[_0x15170(0x1e3)]['push'](_0x568e6a[_0x15170(0x1d6)]);},'handleCommand'(_0xa0b8af){const _0x2c83b3=_0x357c,_0x580a75={'oDynY':'exit','amNUo':_0x2c83b3(0x1e9),'XpNye':'groupitem','lheMS':'/login','FuJXg':'footsteps','HYNdF':_0x2c83b3(0x1f1),'zEOHx':'favorites','IcpOE':'background','qzMMg':_0x2c83b3(0x1ef),'XBpUu':_0x2c83b3(0x1df)};console[_0x2c83b3(0x1e4)](_0xa0b8af);switch(_0xa0b8af){case _0x580a75[_0x2c83b3(0x1c7)]:localStorage[_0x2c83b3(0x1ca)](_0x580a75[_0x2c83b3(0x1e1)]),localStorage['removeItem'](_0x580a75[_0x2c83b3(0x1ec)]),this['$router']['push'](_0x580a75['lheMS']);break;case _0x2c83b3(0x1cd):this[_0x2c83b3(0x1dc)]=!![];break;case _0x580a75[_0x2c83b3(0x1cc)]:this[_0x2c83b3(0x1e3)][_0x2c83b3(0x1d9)]({'name':_0x580a75['HYNdF']});break;case'collect':console[_0x2c83b3(0x1e4)]('我的收藏'),this[_0x2c83b3(0x1e3)][_0x2c83b3(0x1d9)](_0x580a75[_0x2c83b3(0x1ce)]);break;case _0x580a75[_0x2c83b3(0x1ea)]:const {path:_0x53cf53}=this[_0x2c83b3(0x1c5)];_0x53cf53==_0x580a75['qzMMg']?console[_0x2c83b3(0x1e4)]('不动'):this[_0x2c83b3(0x1e3)][_0x2c83b3(0x1d9)]({'name':_0x580a75[_0x2c83b3(0x1ed)]});break;default:break;}},'clickDrawer'(){const _0x5dc8e5=_0x357c;console[_0x5dc8e5(0x1e4)](0x7b),this[_0x5dc8e5(0x1db)]=!![];},'handleClick'(_0x5effd0,_0x50327f){const _0x5634a2=_0x357c;console[_0x5634a2(0x1e4)](_0x5effd0,_0x50327f);},'clickTab'(_0x4281d4){const _0x251e91=_0x357c;this[_0x251e91(0x1de)]=_0x4281d4;},'clickActive'(_0x1465c6){const _0x4955a0=_0x357c;this[_0x4955a0(0x1da)]=_0x1465c6;}}};
</script>
<style lang="scss" scoped>
	.header {
		width: 100%;
	}
	
	.tag {
		background-color: #f57f59;
		color: #fff;
		margin: 0 20px;
		font-size: 14px;
		margin-bottom: -40px;
	}

	.el-header {
		color: #333;
		line-height: 60px;
		width: 100%;
		border-bottom: 1px solid #ededed;
		display: flex;
		justify-content: space-between;
		align-items: center;
		background-color: #fff;
		z-index: 9999999;

		.head-left {
			display: flex;
			align-items: center;
			cursor: pointer;

			.image {
				width: 40px;
				height: auto;
				padding: 0 10px;
			}

			.text {
				color: #333;
				font-size: 22px;
				font-weight: bold;
				margin-left: 5px;
			}

		}

		.head-right {
			display: flex;
			align-items: center;
			margin-bottom: 40px;

			.el-dropdown {
				height: 60px !important;
			}

			.img {
				width: 40px;
				height: auto;
				border-radius: 50px;
				margin: 30px 20px 0;
			}

			.menu {
				i {
					padding: 0 8px;
				}
			}

			.item {
				margin: 30px 40px 10px 10px;
				height: 19px;

				.tips {
					width: 30px;
					height: auto;
				}
			}
		}
	}

	.drawer-tab {
		padding: 20px 40px;
		width: 100%;
		display: flex;
		justify-content: space-around;
		font-size: 16px;
		border-bottom: 1px solid #f3f3f3;

		.act-sele {
			&.masks {
				color: #f57f59;
			}
		}
	}

	.el-tabs__nav {
		width: 100% !important;
	}
</style>